<template>
  <v-layout class="forgot-password" justify-center>
    <v-card flat color="transparent">

      <logo-header-card />

      <v-card-text>
        <p>Enter your email address below, and a link to reset your password will be sent immediately.</p>
        <v-form v-model="valid">
          <v-text-field flat outline label="E-mail" v-model="email" :rules="emailRules" required class="form-input"></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" @click="doResetPassword()" :disabled="!valid">Reset password</v-btn>
      </v-card-actions>

    </v-card>
  </v-layout>
</template>

<style lang="scss" scoped>
$primaryColor: #1565c0;

.forgot-password {
  .v-card {
    max-width: 520px;
    width: 100%;
  }
}

</style>

<script>
import { mapActions } from 'vuex'
import LogoHeaderCard from '@/components/cards/LogoHeaderCard'
import bus from '@/core/helpers/bus'

export default {
  components: {
    LogoHeaderCard
  },
  data() {
    return {
      valid: false,

      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          'E-mail must be valid'
      ]
    }
  },
  computed: {
    showSpecialtyLogo() {
      if (window.location.host.includes('smartchoice')) {
        return 'https://storage.googleapis.com/onechart-assets/sclogo.png'
      } else if (window.location.host.includes('grayhawk')) {
        return 'https://storage.googleapis.com/onechart-assets/logos/1699131904.png'
      } else {
        return null
      }
    }
  },
  methods: {
    ...mapActions('auth', ['resetPassword']),
    doResetPassword() {
      console.log(this.email)
      this.resetPassword({ email: this.email })
      this.toast('success', 'Password reset link sent')
      this.$router.push({name: 'home'})
    },
    toast(type, text) {
      bus.$emit('toast', { type, text })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/auth/ForgotPasswordPage.vue